import React, { useState } from 'react';
import { ButtonField, InputField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import HttpService from "../../../config/http.service";
import { API_USER } from '../../../config/constants';
import { Toast } from '../../../services';

const AddPrivilege = ({ isAddPrivilege, setIsAddPrivilegeOpen }: any) => {
    const [newprivilege, setNewprivilege] = useState('')
    const [privilegeDescription, setPrivilegeDescription] = useState('');
    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setNewprivilege('');
            setPrivilegeDescription('');
            setIsAddPrivilegeOpen(false);
        }
    }

    const addPrivilege = () => {
        if (!newprivilege || !newprivilege.trim()) {
            Toast('Please enter privilege name', "error");
            return;
        }
        if (!privilegeDescription || !privilegeDescription.trim()) {
            Toast('Please enter privilege description', "error");
            return;
        }
        const payload = { name: newprivilege.trim(), description: privilegeDescription.trim() };
        HttpService.postRequest(API_USER.ADD_PRIVILEGE, payload).then(
            (res: any) => {
                setNewprivilege('');
                setPrivilegeDescription('');
                setIsAddPrivilegeOpen(false);
                Toast("Privilege added successfully.", "success");
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <>
            <Modal
                isOpen={isAddPrivilege}
                srLabelledBy={'modal-id-001'}
                srDescribedBy={'modal-id-002'}
                width={'432px'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-001'}
                    isFullscreenButtonVisible
                    onUserRequest={() => handleUserRequest('header')}>
                    Add Privilege{' '}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-002">

                    <div className="wk-row">
                        <div className="wk-col-12">
                            <InputField
                                label="Privilege Name"
                                labelFor="privilege-1"
                                size="small"
                                indicator="required">
                                <input
                                    type="text"
                                    id="privilege-1"
                                    name="privilege"
                                    value={newprivilege}
                                    onChange={e => setNewprivilege(e.target.value)}
                                    placeholder="Enter new privilege"
                                    autoComplete="off"
                                />
                            </InputField>
                        </div>
                    </div>

                    <div className="wk-row">
                        <div className="wk-col-12">
                            <InputField
                                label="Description"
                                labelFor="privilege-description"
                                size="small"
                                indicator="required">
                                <textarea
                                    id="privilege-description"
                                    name="description"
                                    value={privilegeDescription}
                                    onChange={e => setPrivilegeDescription(e.target.value)}
                                    placeholder="Enter privilege description"
                                    autoComplete="off"
                                    rows={4}
                                />
                            </InputField>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'text'}>
                                <button type="button" id="cancel" onClick={() => handleUserRequest('footer')}>
                                    Cancel
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'}>
                                <button type="button" id="add" disabled={!newprivilege.trim() || !privilegeDescription.trim()} onClick={() => addPrivilege()}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal >
        </>
    );
};

export default AddPrivilege;
